module.exports = __webpack_public_path__ + "static/media/landing-min.ae63e2ba.jpg";